import React, { useEffect, useState, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { FileDropZone, excel } from 'components/layout/mui-dropzone';
import {
  setOpportunityImportSelectedChannel, setImportRows, validateGeoOnServer, autoFillDescriptives, setImportGeoValidationResult,
  submitImport, setImportOpportunityStatus, setImportName, setConfirmationModalState, setImportRowsSkippedCount, setIsFromRejectedImports,
  setImportRawData, appNotify, setImportNameValidation, setImportDupCheckErrors, setImportLoadingOverlayState, revalidateImportRows
} from 'store/actions';
import { importTypeStateSelector, canImportSelector } from 'store/selectors';
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Tooltip,
  Divider,
  Typography,
  TextField,
  Paper,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent
} from '@material-ui/core/';
import { ButtonDropdown } from 'components/layout';
import { LocationVerificationModal } from 'components/underwrite/acquisition/import/importOpportunities/LocationVerification';
import { BulkLocationVerificationModal } from 'components/underwrite/acquisition/import/importOpportunities/LocationVerification';
import { ImportOpportunitiesGrid } from 'components/underwrite/acquisition/import/importOpportunities';
import { ImportExpander, InlineBadge } from 'components/underwrite/shared/import';
import xlsxSampleSheet from 'static/assets/ReVUe_SampleImport.xlsx';
import { sendClientLog } from 'services/logService';
import debounce from 'lodash/debounce';
import { Constants } from 'utilities/constants';
import { format } from 'date-fns';
import dataGridExtension from 'components/devExtreme/dataGridExtension';

const gridRef = createRef();

const _debounce = debounce(fn => fn(), 1000); // Keep this outside component to prevent losing the debounce instance on rerenders

const ImportOpportunitiesControls = ({
  classes,
  history,
  importSelectedChannel,
  canImport,
  importGeoValidationResult,
  importRows,
  isFromRejectedImports,
  importOpportunityStatus,
  importName,
  importNameValidation,
  gridEditDirty,
  geoValidationResult,
  dupCheckErrors,
  importRowsSkippedCount,
  appSettings,
  setOpportunityImportSelectedChannel,
  setImportRows,
  setImportRowsSkippedCount,
  revalidateImportRows,
  validateGeoOnServer,
  autoFillDescriptives,
  setImportGeoValidationResult,
  setImportDupCheckErrors,
  setConfirmationModalState,
  submitImport,
  setImportOpportunityStatus,
  setImportName,
  setImportNameValidation,
  redirectToImportStatusTab,
  setImportRawData,
  setImportLoadingOverlayState,
  setIsFromRejectedImports,
  appNotify
}) => {
  // const [containsCounty, setContainsCounty] = useState(false); // This is to check if the address object returned from google autocomplete contains a county/equivalent. (ex: Don't allow users submit if they type a state)
  const [openLocationVerification, setOpenLocationVerification] = useState(false);
  const [openBulkLocationVerification, setOpenBulkLocationVerification] = useState(false);
  const [addressToVerify, setAddressToVerify] = useState(null);
  const [bulkAddressToVerify, setBulkAddressToVerify] = useState(null);
  const [contextRowKey, setContextRowKey] = useState(null);
  const [filterByErrors, setFilterByErrors] = useState(false);
  const [localImportName, setLocalImportName] = useState('');
  const invalidZipCodes = geoValidationResult.invalidZipCodes || [];
  const invalidCounties = geoValidationResult.invalidCounties || [];
  const invalidGeo = geoValidationResult.invalidGeo || [];
  const dupRowReferenceIds = dupCheckErrors?.map(error => error.referenceId) || [];
  const hasErrors = importRows.some(row => row.invalidColumns?.length > 0) || invalidZipCodes.length || invalidCounties.length || invalidGeo.length || dupRowReferenceIds.length;
  const maxCountExceeded = importRows?.length > Constants.ImportMaxCount.OPPORTUNITIES;

  useEffect(() => {
    sendClientLog('Info', 'Import - User loaded Opportunities import tab');
  }, []);

  useEffect(() => {
    const dataSource = gridRef.current.instance.getDataSource();
    if (!(dataSource && importRows)) return;

    if (filterByErrors) {
      if (!hasErrors) { // If no more errors (or if no importRows), automatically set filter toggle off and remove from grid
        setFilterByErrors(false);
        gridRef.current.instance.clearFilter();
      } else { // Else, apply filter to grid data
        gridRef.current.instance.filter(row => {
          return row.invalidColumns?.length > 0 || invalidZipCodes.includes(row.zipCode) || invalidCounties.includes(row.referenceId) || invalidGeo.includes(row.referenceId) || dupRowReferenceIds.includes(row.referenceId);
        });
      }
    } else if (gridRef.current.instance.filter()) { // If filter toggle is off, clear filter from grid
      gridRef.current.instance.clearFilter();
    }
  }, [importRows, filterByErrors])

  useEffect(() => {
    if (importName !== localImportName) {
      setLocalImportName(importName);
    }
  }, [importName]);

  const onDropZoneFilesAdded = async (addedFiles) => {
    let combinedData = [];
    try {
      setImportLoadingOverlayState({ // Start displaying loading here since sheets with high row count can take some time. Loading will be turned off in importRawDataSaga after validation is finished.
        isLoading: true,
        message: `Loading file...`
      });
      for (const file of addedFiles) {
        if (excel.excelMimeTypes.indexOf(file.type.toLowerCase()) >= 0) {
          const spreadsheet = await excel.parseExcel(file);
          // Only importing first sheet, should import all?
          console.log(spreadsheet)
          const DragAndDropData = spreadsheet[Object.keys(spreadsheet)[0]];
          combinedData = combinedData.concat(DragAndDropData);
          //console.log(spreadsheet);
          // setImportRawData(spreadsheet);
        } else {
          // const text = await files.loadFileAsText(file);
          //console.log(text);
        }
      }
      if (filterByErrors) {
        setFilterByErrors(false);
      }
      setImportRawData(combinedData, 'file');
    } catch {
      setImportLoadingOverlayState({
        isLoading: false,
        message: null
      });
    }
  }
  const onDropZoneFilesRejected = files => {
    //console.log('Files rejected:', files);
  }

  const handlePaste = async e => {
    // First, ask the Permissions API if we have some kind of access to
    // the "clipboard-read" feature.
    // await navigator.permissions.revoke({name:'clipboard-read'}).then(function(result) {
    //   console.log(result.state);
    // });
    const result = await navigator.permissions.query({ name: 'clipboard-read' });
    console.log(navigator.permissions)
    // If permission to read the clipboard is granted or if the user will
    // be prompted to allow it, we proceed.
    console.log(result.state)
    // if (result.state === 'granted' || result.state === 'prompt') {
    try {
      const data = await navigator.clipboard.readText();
      // console.log(data);
      if (filterByErrors) {
        setFilterByErrors(false);
      }
      setImportRawData(data, 'paste');
    } catch (err) {
      // alert('Paste Error: ' + JSON.stringify(err));
      // Snackbar instead of alert message, unsure how to reproduce this error. Maybe if clipboard permission is not allowed?
      //TODO: perhaps generate a nicer message to the user?
      appNotify(`Paste Error: ${JSON.stringify(err)}`, 'error');
    }
    // } else {
    //   console.log(result.state)
    //   appNotify(`Unable to read from clipboard`, 'error');
    // }
  };

  // Clear click, hide validation error message and set import rows to []
  const handleClearClick = () => {
    resetGeoValidationResult();
    resetDupCheckResult();
    setImportRows([]); // clear out rows
    setImportRowsSkippedCount(0);
    if (isFromRejectedImports) { // If in rejected imports mode, exit
      setIsFromRejectedImports(false);
      setImportName('');
    }
  };

  const handleExport = () => {
    const timestamp = format(new Date(), '_yyyy-MM-dd_HHmmss');
    const fileName = 'ReVUe_OpportunityImport' + timestamp;
    const sheetName = 'Sheet';
    const customizeCell = options => {
      const { excelCell, gridCell } = options;
      const { data, column } = gridCell;
      if (!data?.invalidColumns?.length) return;
      if (data.invalidColumns.some(col => col.name === column.dataField)) { // Check if current cell's column is contained in invalidColumns
        excelCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00ffc9c9' }
        }
      }
    }
    dataGridExtension.exportToExcel(gridRef, fileName, sheetName, customizeCell);
    sendClientLog('Info', 'Import - User exported Opportunities grid to Excel');
  }

  const onSubmitImport = () => {
    if (importRows.length === 0) {
      appNotify('Please Add Data', 'warning');
      return;
    }
    if (!canImport) {
      if (importGeoValidationResult.invalidGeo.length > 0) {
        appNotify('Please verify Location', 'warning');
      } else {
        appNotify('Please fix invalid input', 'warning');
      }
      return;
    }
    setConfirmationModalState({ // Open confirmation modal
      isModalOpen: true,
      handleConfirmation: handleSubmitImportConfirmation,
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to import ${importRows.length} transaction opportunities?`
    });
  };

  const handleSubmitImportConfirmation = () => {
    closeConfirmationModal();
    submitImport(onSubmitImportSuccess);
    sendClientLog('Info', `Import - User clicked Import for ${importRows.length} opportunities.`);
  }
  const onSubmitImportSuccess = () => {
    resetGeoValidationResult();
    resetDupCheckResult();
    redirectToImportStatusTab(history);
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const onValidateGeoClick = () => {
    if (importRows.length === 0) { // Check if there even is data to be imported
      appNotify('Please Add Data', 'warning');
      return;
    }
    if (!canImport) {
      appNotify('Please fix invalid input', 'warning');
      return;
    }
    resetGeoValidationResult();
    validateGeoOnServer();
  }

  const onAutoFillClick = (e) => {
    if (importRows.length === 0) { // Check if there even is data to be imported
      appNotify('Please Add Data', 'warning');
      return;
    }
    if (importName.length < 3) {
      setImportNameValidation({ valid: false, message: "Import name must have a minimum of 3 characters." });
    }
    sendClientLog('Info', `Import - User clicked autofill.`);
    resetGeoValidationResult();// Need to rest server validation result otherwise when auto fill corrects error UI will still show that row/cell is invalid
    autoFillDescriptives(e.value);
  }

  const resetGeoValidationResult = () => {
    setImportGeoValidationResult({ passedValidation: null, invalidZipCodes: null, invalidCounties: null, invalidGeo: null });
  }

  const resetDupCheckResult = () => {
    setImportDupCheckErrors([]);
  }

  const onFormSubmit = e => {
    e.preventDefault();
  }

  const onImportNameChange = e => {
    const value = e?.target?.value ?? "";
    setLocalImportName(value)
    _debounce(() => setImportName(value));
  }

  const handleSelectedChannelChange = e => {
    if (e.target.value !== importSelectedChannel) {
      setOpportunityImportSelectedChannel(e.target.value);
      handleClearClick(); // clear any loaded data
    }
  }

  const getErrorCells = () => {
    let errorArray = [];
    if (importRows.length) {
      importRows.forEach(row => {
        if (row.invalidColumns?.length > 0) {
          row.invalidColumns.forEach(column => {
            const err = errorArray.find(el => el.message === column.message);
            if (err) {
              err.count += 1;
            } else {
              errorArray.push({
                message: column.message,
                count: 1
              })
            }
          });
        }
      });
    }

    // Send all notifications in an array
    return errorArray;
  }

  const handleLocationVerificationClose = e => {
    setOpenLocationVerification(false);
  }

  const handleBulkLocationVerificationClose = e => {
    setOpenBulkLocationVerification(false);
  }

  const updateLocation = geoResultDto => {
    const { invalidZipCodes, invalidCounties, invalidGeo, geoValidationDtos } = geoValidationResult;
    const newImportRows = importRows.map(row => { // Update grid with new location
      if (row.referenceId === contextRowKey) {
        return {
          ...row,
          latitude: geoResultDto.propertyMasterResult.latitude,
          longitude: geoResultDto.propertyMasterResult.longitude,
          street: geoResultDto.propertyMasterResult.cleanAddress,
          city: geoResultDto.propertyMasterResult.city,
          county: geoResultDto.propertyMasterResult.county,
          state: geoResultDto.propertyMasterResult.state,
          zipCode: geoResultDto.propertyMasterResult.zip,
          locationVerificationUsed: true
        }
      }
      return row;
    })
    // If missing lat/long was the only reason for failed validation, and the user has placed a pin in LocationVerification to provide lat/long, mark property as passed
    const overridePassedValidation = geoResultDto.onlyMissingLatLong && geoResultDto.propertyMasterResult.latitude && geoResultDto.propertyMasterResult.latitude
      ? true
      : geoResultDto.passedValidation
    const newGeoValidationDtos = geoValidationDtos.map(dto => { // Update geo validation results with new location
      if (dto.referenceId === contextRowKey) {
        return {
          ...dto,
          street: geoResultDto.propertyMasterResult.cleanAddress,
          zipCode: geoResultDto.propertyMasterResult.zip,
          geoResultDto: {
            ...geoResultDto,
            passedValidation: overridePassedValidation
          }
        }
      }
      return dto;
    })
    const newInvalidGeo = invalidGeo && (geoResultDto.locationCreated || overridePassedValidation) ? invalidGeo.filter(id => id !== contextRowKey) : invalidGeo;
    const newPassedValidation = !invalidZipCodes.length && !invalidCounties.length && !newInvalidGeo?.length;
    setImportGeoValidationResult({
      passedValidation: newPassedValidation,
      invalidZipCodes,
      invalidCounties,
      invalidGeo: newInvalidGeo,
      geoValidationDtos: newGeoValidationDtos
    });
    setImportRows(newImportRows);
  }

  const bulkUpdateLocation = (propertiesCreated) => {
    const { invalidZipCodes, invalidCounties, invalidGeo, geoValidationDtos } = geoValidationResult;
    const newImportRows = importRows.map(row => { // Update grid with new location
      const prop = propertiesCreated.find(x=> x.referenceId === row.referenceId);
      if (prop) {
        return {
          ...row,
          latitude: prop.propertyMasterResult.latitude,
          longitude: prop.propertyMasterResult.longitude,
          street: prop.propertyMasterResult.cleanAddress,
          city: prop.propertyMasterResult.city,
          county: prop.propertyMasterResult.county,
          state: prop.propertyMasterResult.state,
          zipCode: prop.propertyMasterResult.zip,
          locationVerificationUsed: row.locationVerificationUsed || prop.locationVerificationUsed // retain previous value
        }
      }
      return row;
    })

    const newGeoValidationDtos = geoValidationDtos.map(dto => { 
      const prop = propertiesCreated.find( c => c.referenceId === dto.referenceId); 
      if (prop) {
        const overridePassedValidation = prop.onlyMissingLatLong && prop.propertyMasterResult.latitude && prop.propertyMasterResult.latitude
        ? true
        : prop.passedValidation;
        return {
          ...dto,
          street: prop.propertyMasterResult.cleanAddress,
          zipCode: prop.propertyMasterResult.zip,
          geoResultDto: {
            ...prop,
            passedValidation: overridePassedValidation
          }
        }
      }
      return dto;
    })
    
    const newInvalidGeo = invalidGeo && (propertiesCreated.some(p => p.locationCreated)) ? invalidGeo.filter(id => !propertiesCreated.some(p => p.referenceId === id && p.locationCreated)) : invalidGeo;
    const newPassedValidation = !invalidZipCodes.length && !invalidCounties.length && !newInvalidGeo?.length;
    setImportGeoValidationResult({
      passedValidation: newPassedValidation,
      invalidZipCodes,
      invalidCounties,
      invalidGeo: newInvalidGeo,
      geoValidationDtos: newGeoValidationDtos
    });
    setImportRows(newImportRows);
  }

  const FileDropZoneWrapper = ({ children, disabled }) => {
    if (!disabled) return children;

    return <div style={{ position: 'relative' }}>
      <div style={{
        backgroundColor: 'rgb(214 214 214 / 72%)',
        position: 'absolute',
        width: '100%',
        height: '100%'
      }}/>
      {children}
    </div>
  }

  const onRemoveAllClick = errorType => {
    setConfirmationModalState({ // Open confirmation modal
      isModalOpen: true,
      handleConfirmation: () => handleRemoveAllErrorRows(errorType),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to remove all rows with errors?`
    });
  }

  const onVerifyAllClick = () => {
    const geoValidationDto = geoValidationResult.geoValidationDtos
      .filter( c => invalidGeo.includes(c.referenceId))
      .map( c =>  {
        const row = importRows.find(i => i.referenceId === c.referenceId);
        return {
          ...c,
          sourceId: row.sourceId
        };
    });
    setBulkAddressToVerify(geoValidationDto);
    setOpenBulkLocationVerification(true);
  }

  const handleRemoveAllErrorRows = errorType => {
    closeConfirmationModal();
    let filteredRows;
    let deletedKeys = [];
    switch (errorType) {
      case 'format':
        filteredRows = importRows.filter(row => !row.invalidColumns?.length);
        revalidateImportRows(filteredRows);
        break;
      case 'geo':
        filteredRows = importRows.filter(row => {
          const rowHasError = invalidZipCodes.includes(row.zipCode) || invalidCounties.includes(row.referenceId) || invalidGeo.includes(row.referenceId);
          if (rowHasError) {
            deletedKeys.push(row.referenceId);
          }
          return !rowHasError;
        });
        if (!deletedKeys.length) break;
        setImportRows(filteredRows);
        setImportGeoValidationResult({
          passedValidation: true,
          invalidZipCodes: [],
          invalidCounties: [],
          invalidGeo: [],
          geoValidationDtos: geoValidationResult.geoValidationDtos.filter(dto => !deletedKeys.includes(dto.referenceId))
        });
        break;
      case 'dupCheck':
        filteredRows = importRows.filter(row => {
          const rowHasError = dupRowReferenceIds.includes(row.referenceId);
          if (rowHasError) {
            deletedKeys.push(row.referenceId);
          }
          return !rowHasError;
        });
        if (!deletedKeys.length) break;
        setImportRows(filteredRows);
        setImportDupCheckErrors(dupCheckErrors.filter(oldError => !deletedKeys.includes(oldError.referenceId)));
        break;
      default: return;
    }
  }

  const channels = Object.keys(appSettings.Channels).filter(channel => [Constants.Channel.MLS, Constants.Channel.OFFMARKET].includes(channel));
  const errorCells = getErrorCells();
  const hasGeoErrors = (invalidZipCodes?.length) || (invalidCounties?.length) || (invalidGeo?.length);
  return (
    <>
      <Dialog open={importSelectedChannel === ''} 
      disablePortal 
      style={{position: 'absolute'}} 
      BackdropProps={{
        classes: { root: classes.backdrop }
      }}
      classes={{root: classes.root}}
      disableBackdropClick>
        <DialogTitle>Select a channel to import</DialogTitle>
        <DialogContent>
          <FormControl style={{ minWidth: '100px', width: '100%' }} className={classes.alignment}>
            <InputLabel htmlFor="program-helper">Channel</InputLabel>
            <Select value={importSelectedChannel} onChange={(e) => {
              handleSelectedChannelChange(e);
              gridRef.current.instance.repaint()}} inputProps={{ id: 'program-helper' }}>
              {channels.map(channel => {
                return <MenuItem key={channel} value={channel}>{appSettings.Channels[channel].displayName}</MenuItem>
              })}
            </Select>
          </FormControl>
        </DialogContent>
      </Dialog> 
      <div className={classes.container}>
        <div className={classes.leftControls}>
          <form autoComplete="off" onSubmit={onFormSubmit}>
            <FormControl style={{ minWidth: '100px', marginLeft: '0px', marginRight: '30px' }} className={classes.alignment}>
              <InputLabel htmlFor="program-helper">Channel</InputLabel>
              <Select
                value={importSelectedChannel}
                onChange={handleSelectedChannelChange}
                inputProps={{ id: 'program-helper' }}
                disabled={isFromRejectedImports}
              >
                {channels.map(channel => {
                  return <MenuItem key={channel} value={channel}>{appSettings.Channels[channel].displayName}</MenuItem>
                })}
              </Select>
            </FormControl>
          </form>
          {importSelectedChannel === Constants.Channel.OFFMARKET &&
            <form autoComplete="off" onSubmit={onFormSubmit}>
              <FormControl style={{ minWidth: '134px', marginLeft: '0px', marginRight: '30px' }} className={classes.alignment}>
                <InputLabel htmlFor="opp-status">Opportunity Status</InputLabel>
                <Select
                  value={importOpportunityStatus}
                  onChange={e => setImportOpportunityStatus(e.target.value)}
                  inputProps={{ id: 'opp-status' }}
                  disabled={isFromRejectedImports}
                >
                  <MenuItem value={Constants.OpportunityStatus.PRESCREEN}>Pre-Screen</MenuItem>
                  <MenuItem value={Constants.OpportunityStatus.INITIAL}>Initial</MenuItem>
                </Select>
              </FormControl>
            </form>
          }
          <Divider className={classes.verticalDivider} />
          <TextField
            error={importNameValidation.valid === false}
            required
            label="Import Name"
            onChange={onImportNameChange}
            value={localImportName}
            helperText={importNameValidation.message}
            FormHelperTextProps={importNameValidation.isWarning ? { className: classes.isWarning } : {}}
            disabled={isFromRejectedImports}
          />
          <Divider className={classes.verticalDivider} />
          <ButtonDropdown
            title='Autofill'
            // tooltip='Autofill missing indicatives'
            onSelect={onAutoFillClick}
            items={[{ text: 'Blanks Only', value: 'blanks' }, { text: 'All Fields', value: 'all' }]}
            style={{ margin: '0 4px 0 4px' }}
            buttonWidth={119}
            menuWidth={119}
            disabled={gridEditDirty || maxCountExceeded}
          />
          <Divider className={classes.verticalDivider} />
          <Tooltip title="Validate zipcode, county and geo location">
            <div>
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: '4px', marginRight: '4px' }}
                onClick={onValidateGeoClick}
                disabled={!importRows.length || importGeoValidationResult.passedValidation || gridEditDirty || maxCountExceeded}
              >
                Validate Geo
            </Button>
            </div>
          </Tooltip>
          <Divider className={classes.verticalDivider} />
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: '4px', marginRight: '4px' }}
            onClick={onSubmitImport}
            disabled={!importGeoValidationResult.passedValidation || !canImport || gridEditDirty || maxCountExceeded || importName.length === 0 || (importNameValidation.valid == null || importNameValidation.valid === false)}
          >
            Import
          </Button>
        </div>
        <div className={classes.centerControls}>
          <Typography variant='h5' noWrap>{`${isFromRejectedImports ? 'Rejected ' : ''}Opportunity Import`}</Typography>
        </div>
        <div className={classes.rightControls} >
          <Button variant='outlined' color='primary' onClick={handlePaste} disabled={isFromRejectedImports}>
            Paste from Clipboard
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ marginLeft: '4px', marginRight: '4px' }}
            onClick={handleClearClick}
            disabled={!importRows.length}
          >
            Clear
          </Button>
          <Tooltip title="Export with validation errors">
            <div>
              <Button
                variant="contained"
                color="primary"
                // style={{ marginLeft: '4px', marginRight: '4px' }}
                onClick={handleExport}
                // disabled={!importRows.length || canImport || filterByErrors}
                disabled={!importRows.length || gridEditDirty}
              >
                Export
              </Button>
            </div>
          </Tooltip>
          <Divider className={classes.verticalDivider} />
          <a href={xlsxSampleSheet} download="ReVUe_SampleImport.xlsx" className={classes.xlsxSampleButton}>
            <Tooltip title="Download import template">
              <Button variant="outlined" color="primary">
                Sample Sheet
              </Button>
            </Tooltip>
          </a>
        </div>
      </div>
      <FileDropZoneWrapper disabled={isFromRejectedImports}>
        <FileDropZone
          width='100%'
          acceptedMimeTypes={[...excel.excelMimeTypes, 'text/plain']}
          onFilesAdded={isFromRejectedImports ? () => {} : onDropZoneFilesAdded}
          onFilesRejected={onDropZoneFilesRejected}
          elevation={2}
          dragOverElevation={10}
          className='gridFileDropZone'
          style={{ cursor: 'pointer', minHeight: '70px' }}
        />
      </FileDropZoneWrapper>
      {(errorCells.length || importRowsSkippedCount) && !maxCountExceeded
        ? <ImportExpander
          title='Cell errors found'
        >
          <div>
            <FormControlLabel
              control={<Switch checked={filterByErrors} onChange={() => setFilterByErrors(!filterByErrors)} />}
              label="Filter by rows with errors"
              disabled={!hasErrors}
            />
            <Tooltip title='Remove all rows with errors'>
              <span>
                <Button
                    variant="outlined"
                    className={classes.redButton}
                    size='small'
                    style={{ marginLeft: '4px', marginRight: '4px' }}
                    onClick={() => onRemoveAllClick('format')}
                    disabled={!errorCells.length || gridEditDirty || maxCountExceeded}
                >
                  Remove All
                </Button>
              </span>
            </Tooltip>
          </div>
          {errorCells.map(error => {
            return (
              <div key={error.message} className={classes.errorTypeContainer}>
                <InlineBadge className={classes.errorCountBadge} badgeContent={error.count} error color='primary' />
                <Typography>{error.message}</Typography>
              </div>
            )
          })}
          {importRowsSkippedCount > 0
            ? <div className={classes.errorTypeContainer}>
              <InlineBadge className={classes.errorCountBadge} badgeContent={importRowsSkippedCount} color='primary' />
              <Typography>Row skipped - no Source ID found</Typography>
            </div>
            : null
          }
        </ImportExpander>
        : null
      }
      {hasGeoErrors
        ? <ImportExpander
          title='Geo validation errors found'
        >
          <div>
            <FormControlLabel
              control={<Switch checked={filterByErrors} onChange={() => setFilterByErrors(!filterByErrors)} />}
              label="Filter by rows with errors"
              disabled={!hasErrors}
            />
            <Tooltip title='Remove all rows with geo validation errors'>
              <span>
                <Button
                    variant="outlined"
                    className={classes.redButton}
                    size='small'
                    style={{ marginLeft: '4px', marginRight: '4px' }}
                    onClick={() => onRemoveAllClick('geo')}
                    disabled={gridEditDirty || maxCountExceeded}
                >
                  Remove All
                </Button>
              </span>
            </Tooltip>
            { invalidGeo.length > 1 &&
              <Tooltip title='Verify all rows with geo validation errors'> 
                <span >
                  <Button
                      variant="outlined"
                      className={classes.blueButton}
                      size='small'
                      style={{ marginLeft: '4px', marginRight: '4px' }}
                      onClick={() => onVerifyAllClick()}
                      disabled={gridEditDirty || maxCountExceeded}
                  >
                    Verify Locations
                  </Button>
                </span>
              </Tooltip>
            }
          </div>
          {invalidZipCodes.length
            ? <div className={classes.errorTypeContainer}>
              <InlineBadge className={classes.errorCountBadge} badgeContent={invalidZipCodes.length} error color='primary' />
              <Typography>Invalid zip code found</Typography>
            </div>
            : null
          }
          {invalidCounties.length
            ? <div className={classes.errorTypeContainer}>
              <InlineBadge className={classes.errorCountBadge} badgeContent={invalidCounties.length} error color='primary' />
              <Typography>Invalid county found</Typography>
            </div>
            : null
          }
          {invalidGeo.length
            ? <div className={classes.errorTypeContainer}>
              <InlineBadge className={classes.errorCountBadge} badgeContent={invalidGeo.length} error color='primary' />
              <Typography>Property location needs verification</Typography>
            </div>
            : null
          }
        </ImportExpander>
        : null
      }
      {dupCheckErrors?.length
        ? <ImportExpander
          title='Import errors found'
        >
          <div>
            <FormControlLabel
              control={<Switch checked={filterByErrors} onChange={() => setFilterByErrors(!filterByErrors)} />}
              label="Filter by rows with errors"
              disabled={!hasErrors}
            />
            <Tooltip title='Remove all rows with errors'>
              <span>
                <Button
                    variant="outlined"
                    className={classes.redButton}
                    size='small'
                    style={{ marginLeft: '4px', marginRight: '4px' }}
                    onClick={() => onRemoveAllClick('dupCheck')}
                    disabled={gridEditDirty || maxCountExceeded}
                >
                  Remove All
                </Button>
              </span>
            </Tooltip>
          </div>
          {dupCheckErrors.map(error => <div key={error.referenceId} className={classes.errorTypeContainer}><Typography>{error.errorMessage}</Typography></div>)}
        </ImportExpander>
        : null
      }
      <Paper style={{ flexGrow: 1, overflow: 'hidden' }} className={classes.gridPaper}>
        <ImportOpportunitiesGrid
          ref={gridRef}
          setAddressToVerify={setAddressToVerify}
          setOpenLocationVerification={setOpenLocationVerification}
          setContextRowKey={setContextRowKey}
          setBulkAddressToVerify={setBulkAddressToVerify}
          setOpenBulkLocationVerification={setOpenBulkLocationVerification}
        />
        {gridRef.current && openLocationVerification ?
          <LocationVerificationModal open={openLocationVerification} onClose={handleLocationVerificationClose} geoValidationDto={addressToVerify} updateLocation={updateLocation} jitCreationType='opportunities' /> : null
        }
        {gridRef.current && openBulkLocationVerification ?
          <BulkLocationVerificationModal open={openBulkLocationVerification} onClose={handleBulkLocationVerificationClose} 
          geoValidationDto={bulkAddressToVerify} bulkUpdateLocation={bulkUpdateLocation} appSettings={appSettings} 
          setConfirmationModalState={setConfirmationModalState}/> : null
        }
      </Paper>
    </>
  );
};

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  },
  leftControls: {
    display: 'flex',
    width: '40%',
    minWidth: 'fit-content',
    alignItems: 'center',
    minHeight: 68
  },
  rightControls: {
    display: 'flex',
    width: '40%',
    justifyContent: 'flex-end',
    marginBottom: 5
  },
  centerControls: {
    display: 'flex',
  },
  alignment: {
    margin: 0,
    verticalAlign: 'middle'
  },
  xlsxSampleButton: {
    textDecoration: 'none' // Remove text decoration underline from anchor tag to make it look like a button
  },
  verticalDivider: {
    width: 1,
    height: 36,
    margin: '0px 8px',
  },
  gridPaper: {
    padding: '5px 8px 8px'
  },
  errorTypeContainer: {
    display: 'flex',
    marginBottom: 1
  },
  errorCountBadge: {
    marginRight: 8
  },
  root: {
    position: 'absolute',
    zIndex: '1000 !important'
  },
  backdrop: {
    position: 'absolute'
  },
  isWarning: {
    color: theme.palette.warning.text + '!important'
  },
  redButton: {
    color: theme.palette.red.main,
    border: `1px solid ${theme.palette.red.main}80`,
    '&:hover': {
      border: `1px solid ${theme.palette.red.main}`,
      backgroundColor: `${theme.palette.red.main}0a`
    }
  },
  blueButton: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    }
  }
});

const mapStateToProps = state => {
  const opportunitiesState = importTypeStateSelector(state, Constants.ImportType.OPPORTUNITIES);
  const canImport = canImportSelector(state, Constants.ImportType.OPPORTUNITIES);
  return {
    importSelectedChannel: opportunitiesState.importSelectedChannel,
    canImport,  // this only means that import passed CLIENT validation
    importGeoValidationResult: opportunitiesState.importGeoValidationResult,
    importRows: opportunitiesState.importRows,
    isFromRejectedImports: opportunitiesState.isFromRejectedImports,
    importOpportunityStatus: opportunitiesState.importOpportunityStatus,
    importName: opportunitiesState.importName,
    importNameValidation: opportunitiesState.importNameValidation,
    gridEditDirty: opportunitiesState.gridEditDirty,
    geoValidationResult: opportunitiesState.importGeoValidationResult,
    dupCheckErrors: opportunitiesState.importDupCheckErrors,
    importRowsSkippedCount: opportunitiesState.importRowsSkippedCount,
    appSettings: state.appState.appSettings
  }
};
const mapDispatchToProps = dispatch => {
  const importType = Constants.ImportType.OPPORTUNITIES;

  return {
    setOpportunityImportSelectedChannel: channel => dispatch(setOpportunityImportSelectedChannel(channel)),
    setImportRows: importRows => dispatch(setImportRows({ importType, importRows })),
    setImportRowsSkippedCount: importRowsSkippedCount => dispatch(setImportRowsSkippedCount({ importType, importRowsSkippedCount })),
    revalidateImportRows: (rows) => dispatch(revalidateImportRows({ importType, rows })),
    validateGeoOnServer: () => dispatch(validateGeoOnServer({ importType })),
    autoFillDescriptives: fieldType => dispatch(autoFillDescriptives({ importType, fieldType })),
    setImportGeoValidationResult: (importGeoValidationResult) => dispatch(setImportGeoValidationResult({ importType, importGeoValidationResult })),
    setImportDupCheckErrors: (dupCheckErrors) => dispatch(setImportDupCheckErrors({ importType, dupCheckErrors })),
    setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState)),
    submitImport: onSubmitImportSuccess => dispatch(submitImport({ importType, onSubmitImportSuccess })),
    setImportOpportunityStatus: importOpportunityStatus => dispatch(setImportOpportunityStatus({ importType, importOpportunityStatus })),
    setImportName: importName => dispatch(setImportName({ importType, importName })),
    setImportNameValidation: importNameValidation => dispatch(setImportNameValidation({ importType, importNameValidation })),
    redirectToImportStatusTab: history => {
      history.push(Constants.Routes.UNDERWRITE_IMPORT_STATUS);
    },
    setImportRawData: (data, source) => dispatch(setImportRawData({ data, importType, source })),
    setImportLoadingOverlayState: (importLoadingOverlayState) => dispatch(setImportLoadingOverlayState({ importType, importLoadingOverlayState })),
    setIsFromRejectedImports: (isFromRejectedImports) => dispatch(setIsFromRejectedImports({ importType, isFromRejectedImports })),
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options))
  }
};
export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ImportOpportunitiesControls);